<template>
  <div class="ebook-details-section">
    <div class="ebook-details-container">
      <!-- Columna izquierda: Imagen del ebook -->
      <div class="ebook-image-column">
        <div class="ebook-stack">
          <img
            src="@/assets/images/EbookDetail.png"
            alt="Ebook: Del Excel al mantenimiento inteligente"
            class="ebook-image"
          />
        </div>
        <div class="ebook-stats">
          <div class="stat-item">
            <span class="stat-number">5</span>
            <span class="stat-label">Capítulos</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-number">14</span>
            <span class="stat-label">Páginas</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-number">10min</span>
            <span class="stat-label">De lectura</span>
          </div>
        </div>
      </div>

      <!-- Columna derecha: Contenido -->
      <div class="ebook-content-column">
        <div class="content-header">
          <div class="section-badge">
            <div class="badge-line"></div>
            <span class="badge-text">PARA QUIÉN ES</span>
          </div>
          <h2 class="main-title">¿Quién debería leer este ebook?</h2>
        </div>

        <p class="intro-text">
          Pensado para líderes de <strong>mantenimiento, operaciones y facilities</strong> que hoy gestionan activos
          y <strong>OT</strong> en <strong>Excel/WhatsApp</strong> y necesitan trazabilidad, control y auditorías sin fricción.
        </p>

        <ul class="benefits-list">
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined">
check
</span>
            </div>
            <span
              >Gestionas <strong>OT, activos y checklists</strong> en <strong>Excel</strong> y quieres un historial único y
              confiable.</span
            >
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined">
check
</span>
            </div>
            <span>Sufres <strong>paradas no planificadas</strong> y necesitas <strong>alertas, SLAs y aprobaciones</strong>.</span>
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined">
check
</span>
            </div>
            <span>Las <strong>auditorías (ISO, BPM, INVIMA)</strong> te toman días reuniendo evidencias.</span>
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined">
check
</span>
            </div>
            <span>Buscas <strong>estandarizar checklists por equipo/sede</strong> y asignar responsables.</span>
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined">
check
</span>
            </div>
            <span
              ><strong>Necesitas KPIs claros:</strong> MTBF, MTTR, % de cumplimiento de OT y disponibilidad.</span
            >
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined">
check
</span>
            </div>
            <span>Debes <strong>justificar el ROI </strong> de la digitalización con datos y plantillas.</span>
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined">
check
</span>
            </div>
            <span
              >Estás por <strong> migrar a un CMMS/GMAO</strong> y requieres un <strong> checklist paso a paso para carga
              inicial y pruebas.</strong></span>
          </li>
        </ul>

        <button class="download-cta" @click="scrollToForm">
          <span>Descargar ebook</span>
          <svg class="cta-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M7 17L17 7M17 7H7M17 7V17"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const scrollToForm = () => {
  const formElement = document.querySelector('.ebook-form-section')
  if (formElement) {
    formElement.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<style scoped>
.ebook-details-section {
  padding: 80px 20px;
  background: white;
  min-height: 60vh;
}

.ebook-details-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 60px;
  align-items: center;
}

.ebook-image-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ebook-stack {
  position: relative;
}

.ebook-image {
  width: 100%;
  height: 100%;
}

strong {
  font-weight: 700;
}

.ebook-stats {
  display: flex
;
    align-items: center;
    background: #129bef;
    color: white;
    padding: 20px 40px;
    border-radius: 12px;
    gap: 30px;
    box-shadow: 0 8px 25px rgba(18, 155, 239, 0.3);
    position: relative;
    top: -120px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.stat-label {
  font-size: 12px;
  font-weight: 500;
  opacity: 0.9;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.3);
}

.ebook-content-column {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.content-header {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-badge {
  display: flex;
  align-items: center;
  gap: 12px;
}

.badge-line {
  width: 40px;
  height: 2px;
  background: #129bef;
}

.badge-text {
  color: #129bef;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.main-title {
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 600;
  color: #333;
  line-height: 1.2;
  margin: 0;
}

.intro-text {
  font-size: 18px;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

.benefits-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.check-icon {
  width: 30px;
  height: 30px;
  background: #129bef;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.check-icon .material-symbols-outlined {
  color: #fff;
  font-size: 18px;
}

.benefit-item span {
  font-size: 16px;
  line-height: 1.5;
  color: #666;
}

.download-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #129bef;
  color: white;
  border: none;
  padding: 18px 36px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: fit-content;
  margin-top: 20px;
}

.download-cta:hover {
  background: #0ea5e9;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(18, 155, 239, 0.4);
}

.cta-arrow {
  transition: transform 0.3s ease;
}

.download-cta:hover .cta-arrow {
  transform: translate(2px, -2px);
}

@media (max-width: 768px) {
  .ebook-details-section {
    padding: 60px 15px;
  }

  .ebook-details-container {
    grid-template-columns: 1fr;
    gap: 0px;
    text-align: center;
  }

  .ebook-stack {

  }

  .ebook-stats {
    gap: 15px;
  }

  .stat-number {
    font-size: 20px;
  }

  .stat-label {
    font-size: 11px;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .intro-text {
    font-size: 16px;
    text-align: start;
  }

  .benefit-item {
    text-align: left;
  }

  .download-cta {
    width: 100%;
    padding: 16px 32px;
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .ebook-stats {
    gap: 5px;
    padding: 20px 20px;

  }

  .stat-divider {
    width: 40px;
    height: 1px;
  }

  .benefits-list {
    gap: 16px;
  }

  .benefit-item span {
    font-size: 15px;
  }
}
</style>
